export const MAIN_ROUTE = '/';
export const EXAMPLES_ROUTE = '/examples';
export const LAYOUTS_AND_DESIGN_ROUTE = '/layouts_and_design';
export const CONTACTS_ROUTE = '/contacts';
export const SERVICES_ROUTE = '/services';
export const CREATE_DESIGN_ROUTE = '/create_design';
export const ADMIN_ROUTE = '/admin';
export const LOGIN_ROUTE = ADMIN_ROUTE + '/login'
export const EDIT_NEWS_ROUTE = ADMIN_ROUTE + '/news'
export const EDIT_PRICES_ROUTE = ADMIN_ROUTE + '/edit_prices'

export const BASE_URL = 'https://4-zveta.ru/api/';

export const EXAMPLE_CATEGORIES = [
    'Деловая полиграфия',
    'Рекламная печать',
    'Широкоформат и наружная реклама',
    'Наклейки и этикетки',
    'Сувенирная продукция',
    'Другое',
];
